(function () {
  const initSlider = (section) => {
    if (
      !section ||
      !section.classList.contains("features-highlights-section")
    ) {
      return;
    }

    const sliderEl = section.querySelector(".features-highlights-slider");
    if (!sliderEl) return;

    const slidesPerView = Number(sliderEl.dataset.slidesPerView || 4);
    const slidesPerViewMobile = 1.4;
    const slidesPerView576 = 2;
    const slidesPerView750 =
      slidesPerView > 2 ? slidesPerView576 + 1 : slidesPerView576;
    const slidesPerView1160 =
      slidesPerView > 3 ? slidesPerView750 + 1 : slidesPerView750;

    const slides = sliderEl.querySelectorAll(".block-text-with-icon");
    slides.forEach((slide) => {
      slide.classList.add("swiper-slide");
    });

    const updateShadows = (swiper) => {
      if (!swiper || !sliderEl.classList.contains("enable-shadows")) {
        return;
      }

      if (swiper.isBeginning) {
        sliderEl.classList.add("slider-at-start");
      } else {
        sliderEl.classList.remove("slider-at-start");
      }

      if (swiper.isEnd) {
        sliderEl.classList.add("slider-at-end");
      } else {
        sliderEl.classList.remove("slider-at-end");
      }
    };

    const createSwiper = () => new Swiper(sliderEl, {
      loop: false,
      spaceBetween: 8,
      speed: 800,
      slidesPerView: slidesPerViewMobile,
      breakpoints: {
        576: {
          spaceBetween: 12,
          slidesPerView: slidesPerView576,
        },
        750: {
          spaceBetween: 12,
          slidesPerView: slidesPerView750,
        },
        990: {
          spaceBetween: 24,
          slidesPerView: slidesPerView750,
        },
        1160: {
          spaceBetween: 24,
          slidesPerView: slidesPerView1160,
        },
        1360: {
          spaceBetween: 32,
          slidesPerView: slidesPerView1160,
        },
      },
      on: {
        init: function () {
          updateShadows(this);
        },
        slideChange: function () {
          updateShadows(this);
        },
        resize: function () {
          updateShadows(this);
        },
      },
    });

    if (sliderEl.dataset.mobileStack !== "true") {
      createSwiper();
      return;
    }

    // Mobiel: geen slider, items onder elkaar. Vanaf 750px wel een slider.
    const mq = window.matchMedia("(min-width: 750px)");
    let swiperInstance = null;
    const toggle = () => {
      if (mq.matches && !swiperInstance) {
        swiperInstance = createSwiper();
      } else if (!mq.matches && swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    };
    toggle();
    if (mq.addEventListener) {
      mq.addEventListener("change", toggle);
    } else if (mq.addListener) {
      mq.addListener(toggle);
    }
  };

  initSlider(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSlider(event.target);
  });
})();
